import { useState, useMemo } from 'react';

export const useSourceSummaryFilters = (data) => {
  const [filterType, setFilterType] = useState('all');
  const [dateRange, setDateRange] = useState('all');
  const [selectedWebinars, setSelectedWebinars] = useState(new Set());
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);

  const filteredData = useMemo(() => {
    // Safety check: ensure data is an array
    if (!data || !Array.isArray(data) || data.length === 0) {
      console.log('useSourceSummaryFilters: No valid data provided', { data, isArray: Array.isArray(data) });
      return [];
    }

    let filtered = [...data]; // Create a copy to avoid mutation
    
    // console.log('useSourceSummaryFilters: Starting with data:', filtered.length, 'campaigns');
    // console.log('useSourceSummaryFilters: Filter settings:', { filterType, dateRange, selectedWebinarsCount: selectedWebinars.size });
    
    if (filterType === 'dateRange' && dateRange !== 'all') {
      const now = new Date();
      let cutoffDate;
      let endDate = now;
      
      if (dateRange === '7days') {
        cutoffDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      } else if (dateRange === '30days') {
        cutoffDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      } else if (dateRange === '90days') {
        cutoffDate = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);
      } else if (dateRange === 'custom') {
        if (customStartDate) cutoffDate = new Date(customStartDate);
        if (customEndDate) {
          endDate = new Date(customEndDate);
          endDate.setHours(23, 59, 59, 999);
        }
      }
      
      if (cutoffDate) {
        const beforeFilterCount = filtered.length;
        filtered = filtered.filter(row => {
          const rowDate = new Date(row.date);
          return rowDate >= cutoffDate && rowDate <= endDate;
        });
        console.log(`useSourceSummaryFilters: Date filter applied - ${beforeFilterCount} -> ${filtered.length} campaigns`);
      }
    } else if (filterType === 'webinars' && selectedWebinars.size > 0) {
      const beforeFilterCount = filtered.length;
      filtered = filtered.filter(row => selectedWebinars.has(row.id.toString()));
      // console.log(`useSourceSummaryFilters: Webinar filter applied - ${beforeFilterCount} -> ${filtered.length} campaigns`);
    }
    
    // console.log('useSourceSummaryFilters: Final filtered data:', filtered.length, 'campaigns');
    return filtered;
  }, [data, filterType, dateRange, selectedWebinars, customStartDate, customEndDate]);

  // Helper functions
  const toggleWebinarSelection = (webinarId) => {
    const newSelected = new Set(selectedWebinars);
    if (newSelected.has(webinarId.toString())) {
      newSelected.delete(webinarId.toString());
    } else {
      newSelected.add(webinarId.toString());
    }
    setSelectedWebinars(newSelected);
  };

  const clearWebinarSelections = () => {
    setSelectedWebinars(new Set());
  };

  const resetFilters = () => {
    setFilterType('all');
    setDateRange('all');
    setSelectedWebinars(new Set());
    setCustomStartDate('');
    setCustomEndDate('');
    setShowFilterDropdown(false);
  };

  return {
    filterType,
    setFilterType,
    dateRange,
    setDateRange,
    selectedWebinars,
    setSelectedWebinars,
    customStartDate,
    setCustomStartDate,
    customEndDate,
    setCustomEndDate,
    showFilterDropdown,
    setShowFilterDropdown,
    filteredData,
    
    // Helper functions
    toggleWebinarSelection,
    clearWebinarSelections,
    resetFilters
  };
};